import ImageElement from './ImageElement'
import { elementType } from '../vars'

export default class Trash extends ImageElement {
  get suffix() {
    if (!this.spec) return 'Inactive'
    return this.capitalize(this.spec)
  }

  get type() {
    return elementType.TRASH
  }

  get name() {
    return `${this.type}${this.suffix}`
  }

  get alt() {
    return `${this.capitalize(this.type)} ${this.suffix}`
  }

  get isActionable() {
    return true
  }

  get image() {
    if (!this.spec) return this.primaryImage
    // Signal is inactive by default in the toolbar
    return this.spec === 'active' ? this.primaryImage : this.secondaryImage
  }

  onToggle() {
    if (this.spec === 'active') {
      this.spec = 'inactive'
    } else {
      this.spec = 'active'
    }
  }

  onMouseOver() {
    this.spec = 'active'
  }

  onMouseOut() {
    this.spec = 'inactive'
  }
}
